import {RankingStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/RankingStaticLandingPageVo.interface';
import {
  StaticLandingRankingParamInput,
  StaticLandingRankingSectionParam,
} from '../generated/types';
import {createSortOption} from './SortOption';

export function createStaticLandingRankingSectionParam(
  vo: RankingStaticLandingPageVo,
  input: StaticLandingRankingParamInput
): StaticLandingRankingSectionParam {
  return {
    categoryUid: input.categoryUid,
    subcategory: vo.selected_subcat_opt
      ? createSortOption({
          sortOptVo: vo.selected_subcat_opt,
        })
      : undefined,
    rankingType: vo.selected_rank_opt
      ? createSortOption({
          sortOptVo: vo.selected_rank_opt,
        })
      : undefined,
    page: input.page,
    screenUid: input.screenUid,
  };
}
